export default () => `
  <div>
    <div class="sub-header"><strong>NXT UMOUNT Combo Clamp:</strong> 1/2 in gap</div>
  </div>
`;
